<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <!-- <img style="display: none;" id='reportLogo' src='@/assets/report_logo.png' alt='Report Logo'> -->
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Brand">
                                        <a-select showSearch v-model="inputBrands" mode="multiple" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" placeholder="All Brand" allowClear @select="getSubBrandData" @change="clearSubBrand">
                                            <a-select-option v-for="brandOption in brandOptions" :key="brandOption.id" :value="brandOption.id">{{brandOption.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div v-if="subBrandOptions.length > 0" class="row">
                                <div class="col-md-7">
                                    <base-input label="Sub Brand">
                                        <a-select v-model="inputSubBrands" placeholder="Select Sub Brand" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" mode="multiple" showSearch >
                                            <a-select-option
                                            v-for="sub_brand_option in subBrandOptions"
                                            :key="sub_brand_option.id"
                                            :value="sub_brand_option.id"
                                            >{{ sub_brand_option.name }}
                                            </a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        <!-- 
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Group By" >
                                        <select class="form-control" size="large" v-model="inputGroupBy" @click.prevent="autoChange">
                                            <option v-for="option in groupOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                            </div> -->
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Date"><br>
                                        <a-range-picker v-model="inputDate" :showTime="{ format: 'hh:mm' }" format="MM-DD-YYYY hh:mm A" :placeholder="['Start Date', 'End Date']" style="width:100%"/>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Select Site">
                                        <a-select mode="multiple" v-model="inputSite" showSearch placeholder="All Sites" optionFilterProp="children" style="width: 100%" :filterOption="filterOption" >
                                            <a-select-option v-for="option in siteOptions" :key="option.id" :value="option.id">{{option.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
                          
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Product Grade">
                                        <a-select mode="multiple" v-model="inputProductGrade" showSearch placeholder="All Product Group" optionFilterProp="children" style="width: 100%" :filterOption="filterOption"  allowClear >
                                            <a-select-option v-for="productGradeOption in productGradeOptions" :key="productGradeOption.key" :value="productGradeOption.key">{{productGradeOption.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input alternative="" label="Division">
                                        <a-select mode="multiple" v-model="inputDivision" showSearch placeholder="All Division" optionFilterProp="children" style="width: 100%" :filterOption="filterOption"  allowClear >
                                            <a-select-option v-for="divisionOption in divisionOptions" :key="divisionOption.id" :value="divisionOption.id">{{divisionOption.name}}</a-select-option>
                                        </a-select>
                                    </base-input>
                                </div>
                            </div>
        
                            <div class="row">
                                <div class="col-md-7">
                                    <base-input label="Sort By" >
                                        <select class="form-control" size="large" v-model="inputSortBy" @click.prevent="sortChange">>
                                            <option v-for="option in sortOptions" v-bind:value="option.key" v-bind:key="option.key">
                                                {{ option.value }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>
                                <div class="col-md-2 mt-3 pt-3">
                                    <button type="button" class="btn btn-sm btn-link" @click='showSortInfoDiv' >
                                        {{showSortInfo == 'asc' ? 'Ascending (A-Z) ↡' : 'Descending (Z-A) ↟'}}
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-4 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                            <button v-if="JsonData.length < 1" class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateFile">Generate Report</button> &nbsp; &nbsp;

                            <vue-json-to-csv v-if="JsonData.length > 0"  :json-data="JsonData" :csv-title="currentProfile.replace(/_/g, '-')+'-'+currDate.replace(/ /g, '_')">
                                <button id='clickCsvExport' class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%;"> Download CSV </button> &nbsp; &nbsp;
                            </vue-json-to-csv>
                            <button v-if="JsonData.length > 0" class="btn btn-sm btn-success float-right" style="border-radius: 24px; border:0px; width: 20%%;" @click.prevent="generateExcel"> Download excel </button> &nbsp; &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import reportUtils from '../../components/reportUtils'
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import VueJsonToCsv from 'vue-json-to-csv';
    import * as ExcelJS from "exceljs";
    import { saveAs } from "file-saver";
    import { getReportDescription } from '../../utilities';

    import {
        mapState,
        mapActions
    } from 'vuex'

    var component_x;
    export default {
        components: {
            VueJsonToCsv
        },
        data() {
            return {
                spinning: false,
                inputDate: [moment().startOf('day'), moment().endOf('day')],
                inputGroupBy: 'site',
                groupOptions: [
                    {key: '', value: 'None'},
                    {key: 'site', value: 'Sites'},
                ],
                inputSite: [],
                site_type: "ho",
                siteOptions: [],
                inputLocation: [],
                locationOptions: [],
                headerExcelInfo: "",
                // locationPath: [],

                inputSortBy: 'store_name',
                sortOptions: [
                    {key: 'store_name', value: 'Store Name'},
                    {key: 'store_code', value: 'Store Code'},
                    {key: 'floor_date', value: 'Floor Date'},
                    {key: 'division', value: 'Division'},
                    {key: 'stock_no', value: 'Stock No'},
                    {key: 'product_grade', value: 'Product Grade'},
                    {key: 'color', value: 'Color'},
                    {key: 'size', value: 'Size'},
                    {key: 'vend_code', value: 'Vendor Code'},
                    {key: 'section', value: 'Section'},
                    {key: 'current_price', value: 'Current Price'}
                ],
                currDate: moment().format("L_LT").split(":").join(";"),
                isSeparateSite: false,
                isShowDetail: true,
                inputFrom: moment().startOf('month'),
                inputTo: moment().endOf('month'),
                monthFormat: 'MM/YYYY',
                marginSalesReport: [],
                params: {},
                advancedFilterVisible: true,

                showSortInfo: 'asc',
                inputShowTop: 0,
                JsonData: [],
                brandOptions: [],
                subBrandOptions: [],
                inputSubBrands: [],
                inputProductGrade: [],
                productGradeOptions: [
                    {key: 'regular', name: 'Regular'},
                    {key: 'promo', name: 'Promo'},
                    {key: 'sale', name: 'Sale'},
                ],
                inputBrands: [],
                inputDivision: [],
                divisionOptions: [],
                departmentOptions:[],
                inputDepartment: [],
                reportDescription: '',
            }
        },
        mounted: async function () {
            component_x = this;

            var userId = secureStorage.getItem("userId")
            var sites = await HTTPRequest.getRequest(component_x.endPoint + "sites/get_valid_sites?user_id=" + userId, null);
            component_x.siteOptions = sites;
            component_x.sort(component_x.siteOptions);

            if(component_x.categoriesOptions.length == 0){
                var options = await HTTPRequest.getRequest(this.endPoint + 'categories/cascader_view', null);
                component_x.updateCategoriesOptions(options)
            }

            this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null)

            let siteId = secureStorage.getItem("defaultSiteId")
            this.inputSite = [siteId]
            

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }

            this.reportDescription = await getReportDescription(this.currentProfile)
            await component_x.getBrandOptions();
            // await component_x.getProductGroupOptions();
            await component_x.getDivisionOptions();
            await component_x.getDepartmentOptions();
    
        },
        watch: {
        
        },
        computed: {
            ...mapState(['currentProfile', 'endPoint', 'categoriesOptions']),
        },
        methods: {
            ...mapActions(['updateCategoriesOptions']),
            moment,
            async onLocationChange(){
                // alert(this.inputLocation);
                this.siteOptions = await HTTPRequest.getRequest(component_x.endPoint + 'sites/get_valid_sites?location_id=' + this.inputLocation[this.inputLocation.length - 1], null)
                this.locationOptions = await HTTPRequest.getRequest(this.endPoint + 'locations/cascader_view', null);
                this.inputSite = this.siteOptions.map( s => s.id);
            },
            filterOption(input, option) {
                return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
            },
            // Advanced Info
            showSortInfoDiv(){
                this.showSortInfo == 'asc' ? this.showSortInfo = 'desc' : this.showSortInfo = 'asc'
            },
            autoChange(e){
                if(e.target.value == ''){
                    this.isShowDetail = true
                }
            },
            sortChange(e){
                if(e.target.value != 'total_amount' || e.target.value != 'qty'){
                    this.inputShowTop = 0
                }
            },
            sort(data){
                data.sort(function (a, b) {
                    return a.name.localeCompare(b.name);
                });
            },
            convertToCurrency(num){
                return num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
            },
            changeParams(params){
                this.params = params
            },
            async findName(inputArray, optionsArray){
                let data = []
                inputArray.forEach((el) =>{
                    data.push(optionsArray.find(x => x.id === el).name)
                })
                return data
            },
            generateReport: async function () {
                this.spinning = true;
                // let date = [this.inputDate, this.inputDate]
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_to": to_date,
                    "date_from": from_date,
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    "brand_id": this.inputBrands.toString(),
                    "sub_brand_id": this.inputSubBrands.toString(),
                    "division_id": this.inputDivision.toString(),
                    "product_grade_name": this.inputProductGrade.toString(),    
                }
                
                let site_filter,brand_filter,date_filter,product_grade_filter,division_filter,sub_brand_filter,order_filter

                date_filter = `For the Period of ${from_date} to ${to_date}`
                let sort_name = this.sortOptions.find(x => x.key == this.inputSortBy).value
                order_filter =`Sort By ${sort_name} ${this.showSortInfo}`

                if(this.inputSite != undefined && this.inputSite.length > 0 && this.inputSite != [] && this.inputSite.length != this.siteOptions.length ){
                    let sites = this.siteOptions.filter(x => this.inputSite.includes(x.id)).map(x => x.name)
                    site_filter = "Sites: " + sites 
                }else{
                    site_filter = "Sites: All Sites"
                }

                if(this.inputBrands != undefined && this.inputBrands.length > 0 && this.inputBrands != []){
                    let brands = this.brandOptions.filter(x => this.inputBrands.includes(x.id)).map(x => x.name)
                    brand_filter = "Brands: " + brands 
                }else{
                    brand_filter = "Brands: All Brands"
                }

                if(this.inputSubBrands != undefined && this.inputSubBrands.length > 0 && this.inputSubBrands != []){
                    let sub_brands = this.subBrandOptions.filter(x => this.inputSubBrands.includes(x.id)).map(x => x.name)
                    sub_brand_filter = "Sub Brands: " + sub_brands + " and Null"
                }else{
                    sub_brand_filter = "Sub Brands: All Sub Brands"
                }

                if(this.inputProductGrade != undefined && this.inputProductGrade.length > 0 && this.inputProductGrade != [] && this.inputProductGrade.length != this.productGradeOptions.length){
                    let product_grade = this.productGradeOptions.filter(x => this.inputProductGrade.includes(x.key)).map(x => x.name)
                    product_grade_filter = "Product Grades: " + product_grade + " on user defined fields"
                }else{
                    product_grade_filter = "Product Grades: All Product Grades on user defined fields"
                }

                if(this.inputDivision != undefined && this.inputDivision.length > 0 && this.inputDivision != []){
                    let division = this.divisionOptions.filter(x => this.inputDivision.includes(x.id)).map(x => x.name)
                    division_filter = "Divisions: " + division
                }else{
                    division_filter = "Divisions: All Divisions"
                }

                var get_request = await HTTPRequest.getRequest(this.endPoint + 'margin_sales_report?', parameters);
                                
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                    return
                }
                var siteSpecific = get_request;
            
                let design_x = 0
                let design_y = 0


                // -- rank,product_id , product_name,sales, transaction_count,qty_sold,onhand 
                if(siteSpecific.length > 0){
                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'b2' });

                    // let reportLogo = document.getElementById('reportLogo');
                    // doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    let headers = [];
                    headers = [
                        [
                            {content: '#', styles: {width: 'auto',halign: 'center', valign: 'auto'}}, 
                            {content: 'Vendor Code', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Floor Date', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Division', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Stock No', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Color', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Size', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Product Grade', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Misc3', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Section', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Current Price', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Unit Cost', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Store Code', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Store Name', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Sales Quantity', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'OH IT', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'On-hand QTY', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'In Transit QTY', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'OH IT Price', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'OH Cost', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'OH Price', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'IT Cost', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'IT Price', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Received QTY', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Received Cost', styles: {width: 'auto',halign: 'center', valign: 'auto'}},
                            {content: 'Received Price', styles: {width: 'auto',halign: 'center', valign: 'auto'}}
                        ]
                    ]

                    for(let x=0; x < siteSpecific.length; x++){
                        this.marginSalesReportItem = siteSpecific[x].report_details

                        if(x > 0 && this.marginSalesReportItem.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];

                        if(this.marginSalesReportItem.length > 0){

                            for(let i=0; i < this.marginSalesReportItem.length; i++){
                                let reportLine = this.marginSalesReportItem[i]
                                let no = i + 1;
                                if(i == (this.marginSalesReportItem.length - 1)){
                                    no = '';
                                }
                                let detail = []
                                detail = [
                                        no,
                                        reportLine.vendor_code,
                                        reportLine.floor_date,
                                        reportLine.division,
                                        reportLine.stock_no,
                                        reportLine.color,
                                        reportLine.size,
                                        reportLine.product_grade,
                                        reportLine.misc3,
                                        reportLine.section,
                                        this.convertToCurrency(Number(reportLine.current_price)) == 0 ? null : this.convertToCurrency(Number(reportLine.current_price)),
                                        this.convertToCurrency(Number(reportLine.unit_cost)) == 0 ? null : this.convertToCurrency(Number(reportLine.unit_cost)),
                                        reportLine.store_code,
                                        reportLine.store_name,
                                        reportLine.sales_quantity,
                                        reportLine.OH_IT,
                                        reportLine.onhand_quantity,
                                        reportLine.in_transit_quantity,
                                        this.convertToCurrency(Number(reportLine.oh_it_price)),
                                        this.convertToCurrency(Number(reportLine.oh_cost)),
                                        this.convertToCurrency(Number(reportLine.oh_price)),
                                        this.convertToCurrency(Number(reportLine.it_cost)),
                                        this.convertToCurrency(Number(reportLine.it_price)),
                                        reportLine.received_quantity,
                                        this.convertToCurrency(Number(reportLine.received_cost)),
                                        this.convertToCurrency(Number(reportLine.received_price))
                                ]
                            
                                reportData.push(Object.assign({}, detail))

                            }
                        }


                        design_x = 330
                        design_y = 200
                        
                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"Margin Sales Report")
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        
                        doc.text(15,30,date_filter);
                        doc.text(15,34,site_filter);
                        doc.text(15,38,brand_filter);
                        doc.text(15,42,sub_brand_filter);
                        doc.text(15,46,division_filter);
                        doc.text(15,50,product_grade_filter);
                        doc.text(15,54,order_filter);


                        let colStyles = {}

                        colStyles = {
                            0: {cellWidth: 'auto',halign: 'center'},
                            1: {cellWidth: 'auto',halign: 'center'},
                            2: {cellWidth: 'auto',halign: 'center'},
                            3: {cellWidth: 'auto',halign: 'center'},
                            4: {cellWidth: 'auto',halign: 'center'},
                            5: {cellWidth: 'auto',halign: 'center'},
                            6: {cellWidth: 'auto',halign: 'center'},
                            7: {cellWidth: 'auto',halign: 'center'},
                            8: {cellWidth: 'auto',halign: 'center'},
                            9: {cellWidth: 'auto',halign: 'center'},
                            10: {cellWidth: 'auto',halign: 'right'},
                            11: {cellWidth: 'auto',halign: 'right'},
                            12: {cellWidth: 'auto',halign: 'center'},
                            13: {cellWidth: 'auto',halign: 'left'},
                            14: {cellWidth: 'auto',halign: 'right'},
                            15: {cellWidth: 'auto',halign: 'right'},
                            16: {cellWidth: 'auto',halign: 'right'},
                            17: {cellWidth: 'auto',halign: 'right'},
                            18: {cellWidth: 'auto',halign: 'right'},
                            19: {cellWidth: 'auto',halign: 'right'},
                            20: {cellWidth: 'auto',halign: 'right'},
                            21: {cellWidth: 'auto',halign: 'right'},
                            22: {cellWidth: 'auto',halign: 'right'},
                            23: {cellWidth: 'auto',halign: 'right'},
                            24: {cellWidth: 'auto',halign: 'right'},
                            25: {cellWidth: 'auto',halign: 'right'},
                        }


                        doc.autoTable({
                            startY: 63,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'auto',
                            headStyles: {
                                lineWidth: 0.15,
                                cellPadding: 2
                            },
                            margin: { bottom: 30 },
                            styles: {
                                cellPadding: 1.3, fontSize: 10,
                            },
                            columnStyles: colStyles,
                            didParseCell: function(data) {
                                if (data.row.section == 'body' && data.row.raw[0] == 'rowLine'){
                                    data.cell.styles.fillColor = [0, 0, 0, 0, 0, 0]
                                    data.cell.styles.fontSize = 1
                                    data.cell.styles.cellPadding = 0
                                } else if (data.row.section == 'body' && (data.row.raw[13] == 'GRAND TOTAL')){
                                    data.cell.styles.fontStyle = 'bold'
                                }
                            }
                        });


                    }
                    // end loop

                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }

                    let pageCount = doc.internal.getNumberOfPages();
                    
                    for(let i = 1; i <= pageCount; i++) {
                        doc.setPage(i);
                        reportUtils.pdfTools.addFooter(doc, printed_by, "MarginSalesReport", design_x + 360, design_y + 280, i, pageCount)
                    }
                    // await window.open(URL.createObjectURL(doc.output("blob")))
                    doc.save(`MarginSalesReport_${moment().format('YYYYMMDDHHmmss')}.pdf`);
                } else {
                    reportUtils.openNotificationWithIcon(component_x,'warning', 'Try increasing the scope by adjusting the filters.');
                }
                this.spinning = false;

            },
            getBase64Image(url) {
                const img = new Image();
                img.setAttribute('crossOrigin', 'anonymous');
                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    canvas.width = img.width;
                    canvas.height = img.height;
                    const ctx = canvas.getContext("2d");
                    ctx.drawImage(img, 0, 0);
                    const dataURL = canvas.toDataURL("image/png");
                    console.log(dataURL)
                }
                return img.src = url
            },
            async generateExcel(){
                const workbook = new ExcelJS.Workbook();
                    workbook.created = new Date();
                    workbook.modified = new Date();
                    const sheet = workbook.addWorksheet("Margin Sales Report", {
                        pageSetup:{paperSize: 9}
                    });
    
                    let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                    let site_filter,brand_filter,date_filter,product_grade_filter,division_filter,sub_brand_filter,order_filter
                
                    date_filter = `For the Period of ${from_date} to ${to_date}`
                    let sort_name = this.sortOptions.find(x => x.key == this.inputSortBy).value
                    order_filter =`Sort By ${sort_name} ${this.showSortInfo}`

                    if(this.inputSite != undefined && this.inputSite.length > 0 && this.inputSite != [] && this.inputSite.length != this.siteOptions.length ){
                        let sites = this.siteOptions.filter(x => this.inputSite.includes(x.id)).map(x => x.name)
                        site_filter = "Sites: " + sites 
                    }else{
                        site_filter = "Sites: All Sites"
                    }

                    if(this.inputBrands != undefined && this.inputBrands.length > 0 && this.inputBrands != []){
                        let brands = this.brandOptions.filter(x => this.inputBrands.includes(x.id)).map(x => x.name)
                        brand_filter = "Brands: " + brands 
                    }else{
                        brand_filter = "Brands: All Brands"
                    }

                    if(this.inputSubBrands != undefined && this.inputSubBrands.length > 0 && this.inputSubBrands != []){
                        let sub_brands = this.subBrandOptions.filter(x => this.inputSubBrands.includes(x.id)).map(x => x.name)
                        sub_brand_filter = "Sub Brands: " + sub_brands + " and Null"
                    }else{
                        sub_brand_filter = "Sub Brands: All Sub Brands"
                    }

                    if(this.inputProductGrade != undefined && this.inputProductGrade.length > 0 && this.inputProductGrade != [] && this.inputProductGrade.length != this.productGradeOptions.length){
                        let product_grade = this.productGradeOptions.filter(x => this.inputProductGrade.includes(x.key)).map(x => x.name)
                        product_grade_filter = "Product Grades: " + product_grade + " on user defined fields"
                    }else{
                        product_grade_filter = "Product Grades: All Product Grades on user defined fields"
                    }

                    if(this.inputDivision != undefined && this.inputDivision.length > 0 && this.inputDivision != []){
                        let division = this.divisionOptions.filter(x => this.inputDivision.includes(x.id)).map(x => x.name)
                        division_filter = "Divisions: " + division
                    }else{
                        division_filter = "Divisions: All Divisions"
                    }

                    
                    let printed_by = secureStorage.getItem("email")
                    if(printed_by == null){
                        printed_by = ''
                    }
                    let dateNow = moment().format('LL');
                    const data_starts_at_row = 14
    
                    // let reportLogo = document.getElementById('reportLogo');
                
                    // const base64Image = reportUtils.csvxlsxTools.getBase64Image(reportLogo)
    
                    // const imageId2 = workbook.addImage({
                    //     base64: base64Image,
                    //     extension: 'png',
                    // });
    
                    // sheet.addImage(imageId2, {
                    //     tl: { col: 0, row: 0 },
                    //     ext: { width: 61, height: 61 }
                    // });

    
                    sheet.getRow(2).values = [`Margin Sales Report`]
                    // sheet.getRow(5).values = [`For the Period of ${from_header} to ${to_header}`]
                    sheet.getRow(4).values = [`${date_filter}`]
                    sheet.getRow(5).values = [`${site_filter}`]
                    sheet.getRow(6).values = [`${brand_filter}`]
                    sheet.getRow(7).values = [`${sub_brand_filter}`]
                    sheet.getRow(8).values = [`${division_filter}`]
                    sheet.getRow(9).values = [`${product_grade_filter}`]
                    sheet.getRow(10).values = [`${order_filter}`]
                    sheet.getRow(11).values = [`Printed By ${printed_by}`]
                    sheet.getRow(12).values = [`Run Date ${dateNow}`]

                    // sheet.getRow(7).values = [`${filteredOptions}`]
                    
                    
                    //custom header
                    sheet.getRow(data_starts_at_row).values = ["#", "Vendor Code", "Floor Date","Division", "Stock No", 
                    "Color","Size", "Product Grade", "Misc3", "Section", "Current Price",
                    "Unit Cost","Store Code","Store Name","Sales QTY","OH IT","On-hand QTY", "In Transit QTY", "OH IT Price","OH Cost",
                    "OH Price","IT Cost","IT Price","Received QTY", "Received Cost", "Received Price"];
    
                    sheet.columns = [
                        { key: "no" , width: 5 },
                        { key: "vendor_code" , width: 20 },
                        { key: "floor_date", width: 15 },
                        { key: "division", width: 15 },
                        { key: "stock_no" , width: 20 },
                        { key: "color", width: 15 },
                        { key: "size", width: 15 },
                        { key: "product_grade", width: 15 },
                        { key: "misc3", width: 15 },
                        { key: "section", width: 15 },
                        { key: "current_price", width: 15 },
                        { key: "unit_cost", width: 15 },
                        { key: "store_code", width: 15 },
                        { key: "store_name", width: 15 },
                        { key: "sales_quantity", width: 15 },
                        { key: "OH_IT", width: 15 },
                        { key: "onhand_quantity", width: 15 },
                        { key: "in_transit_quantity", width: 15 },
                        { key: "oh_it_price", width: 15 },
                        { key: "oh_cost", width: 15 },
                        { key: "oh_price", width: 15 },
                        { key: "it_cost", width: 15 },
                        { key: "it_price", width: 15 },
                        { key: "received_quantity", width: 15 },
                        { key: "received_cost", width: 15 },
                        { key: "received_price", width: 15 },
                    ];
    
                    var report_details = this.JsonData
                    // var report_details = get_request[0].report_details
                    // console.log("details", report_details)
                    // console.log(this.JsonData)
                    var rowDatas = []
                    var horizontal_range = 0

                    for(let i = 0; i < report_details.length; i++){
                        const report_detail = report_details[i]

                        if(report_detail){
                            const rowData = {no: report_detail['#'],
                            vendor_code: report_detail["Vendor Code"],
                            floor_date: report_detail["Floor Date"],
                            division: report_detail["Division"],
                            stock_no: report_detail["Stock No"],
                            color: report_detail["Color"],
                            size: report_detail["Size"],
                            product_grade: report_detail["Product Grade"],
                            misc3: report_detail["Misc3"],
                            section: report_detail["Section"],
                            current_price: report_detail["Current Price"], 
                            unit_cost: report_detail["Unit Cost"],
                            store_code: report_detail["Store Code"],
                            store_name: report_detail["Store Name"],
                            sales_quantity: report_detail["Sales QTY"],
                            OH_IT: report_detail["OH IT"],
                            onhand_quantity: report_detail["On-hand QTY"],
                            in_transit_quantity: report_detail["In Transit QTY"],
                            oh_it_price: report_detail["OH IT Price"],
                            it_cost: report_detail["IT Cost"],
                            oh_cost: report_detail["OH Cost"],
                            it_price: report_detail["IT Price"],
                            oh_price: report_detail["OH Price"],
                            received_quantity: report_detail["Received QTY"],
                            received_cost: report_detail["Received Cost"],
                            received_price: report_detail["Received Price"]
                            }
                            rowDatas.push(rowData)
                        }

                    }
    
                    sheet.addRows(rowDatas);
    
                    //styles
                    sheet.getRow(2).font = { bold: true, size: 16 };
                    sheet.getRow(2).height = 20;
                    // sheet.getRow(7).font = { bold: true };
                    sheet.getRow(data_starts_at_row).font = { bold: true };
    
                    // sheet.getRow(data_starts_at_row).eachCell({ includeEmpty: true }, function(cell) {
                    //     sheet.getCell(cell.address).fill = { type: 'pattern', pattern: 'darkVertical', fgColor: { argb: '89CFF0'}}
                    // })
    
                    sheet.eachRow(function (Row, rowNum) {
                        if(rowNum >= data_starts_at_row){
                            Row.eachCell(function (Cell, cellNum) {
                                if (rowNum == data_starts_at_row) {
                                    Cell.alignment = {
                                        horizontal: 'center'
                                    }
                                }
                                else{
                                    Cell.alignment = {
                                        vertical: 'middle',
                                        horizontal: 'left'
                                    }
                                }
                            })
                        }
                    })
                    
                    workbook.xlsx.writeBuffer().then(function(buffer) {
                        const blob = new Blob([buffer], { type: "applicationi/xlsx" });
                        saveAs(blob, `MarginSalesReport.xlsx`);
                    });
                    this.JsonData = []
            },
            generateFile: async function() {
                this.spinning = true;
                let {from_date, to_date, from_header, to_header} = reportUtils.buildFromToHeaders(component_x, this.inputGroupBy, this.inputDate)
                let parameters = {
                    "site_id": this.inputSite.toString(),
                    "date_to": to_date,
                    "date_from": from_date,
                    "order": this.inputSortBy,
                    "by": this.showSortInfo,
                    "brand_id": this.inputBrands.toString(),
                    "sub_brand_id": this.inputSubBrands.toString(),
                    "division_id": this.inputDivision.toString(),
                    "product_grade_name": this.inputProductGrade.toString(),
                }
                var get_request = await HTTPRequest.getRequest(this.endPoint + 'margin_sales_report?', parameters);
                if(get_request.error) {
                    reportUtils.openNotificationWithIcon(component_x,'error', get_request.error);
                    return
                }

                if(get_request.length > 0){
                    let siteSpecific = get_request;
                    let headers = ["#", "Vendor Code", "Floor Date","Division", "Stock No", 
                    "Color","Size", "Product Grade", "Misc3", "Section", "Current Price",
                    "Unit Cost","Store Code","Store Name","Sales QTY","OH IT","On-hand QTY", "In Transit QTY", "OH IT Price","OH Cost",
                    "OH Price","IT Cost","IT Price","Received QTY", "Received Cost", "Received Price"
                    ];
                    let site_specific = [];
    
                    for(let x=0; x < siteSpecific.length; x++){
                        this.marginSalesReport = siteSpecific[x].report_details

                        let reportData = [];
                        if(x > 0){
                            // Add second set of headers
                            reportData.push(headers)
                        }
                        if(this.marginSalesReport.length > 0){
                            console.log(this.marginSalesReport.length)
                            let grouper = 'start'
                            for(let i=0; i < this.marginSalesReport.length; i++){
                                let reportLine =this.marginSalesReport[i]
                                let no = i + 1;
                                if(i == (this.marginSalesReport.length - 1)){
                                    no = '';
                                }
                                let detail = []
                                detail = [
                                        no,
                                        reportLine.vendor_code,
                                        reportLine.floor_date,
                                        reportLine.division,
                                        reportLine.stock_no,
                                        reportLine.color,
                                        reportLine.size,
                                        reportLine.product_grade,
                                        reportLine.misc3,
                                        reportLine.section,
                                        this.convertToCurrency(Number(reportLine.current_price)) == 0 ? null : this.convertToCurrency(Number(reportLine.current_price)),
                                        this.convertToCurrency(Number(reportLine.unit_cost)) == 0 ? null : this.convertToCurrency(Number(reportLine.unit_cost)),
                                        reportLine.store_code,
                                        reportLine.store_name,
                                        reportLine.sales_quantity,
                                        reportLine.OH_IT,
                                        reportLine.onhand_quantity,
                                        reportLine.in_transit_quantity,
                                        this.convertToCurrency(Number(reportLine.oh_it_price)),
                                        this.convertToCurrency(Number(reportLine.oh_cost)),
                                        this.convertToCurrency(Number(reportLine.oh_price)),
                                        this.convertToCurrency(Number(reportLine.it_cost)),
                                        this.convertToCurrency(Number(reportLine.it_price)),
                                        reportLine.received_quantity,
                                        this.convertToCurrency(Number(reportLine.received_cost)),
                                        this.convertToCurrency(Number(reportLine.received_price))
                                ]
                                reportData.push(Object.assign({}, detail))
                            }

                        }

                        let printed_by = secureStorage.getItem("email")
                        if(printed_by == null){
                            printed_by = ''
                        }

                        // reportData.push(["Margin Sales Report" + "Generated By: " + printed_by,"For the Period of " + from_header + " to " + to_header])

                        let keys = headers;
                        let values = reportData;
                        var values_length = values.length;

                        let newJsonData=[];

                        // change headers and report data as key and value object
                        for(var i=0;i < values_length; i++){
                            var result =  Object.assign.apply({}, keys.map( (val, index) => ( {
                                [val]: values[i][index]
                                }
                            )
                            )
                        );
                        newJsonData.push(result)
                        }

                        // change undefined on arr
                        newJsonData.forEach(function(obj) {
                        for(var i in obj) {
                            if(obj[i] === undefined || obj[i] === null ) {
                            obj[i] = '';
                            }
                        }
                        });
                        site_specific.push(newJsonData)
                    }
                    // for each site specific[] convert nested to single array
                    this.JsonData = site_specific.flat(Infinity);
                } else {
                    reportUtils.openNotificationWithIcon(component_x, 'warning', 'No Data.');
                }
                this.spinning = false;
            },
            clearJsonData(){
             this.JsonData = [];
            },
            async getBrandOptions() {
                var brands = await HTTPRequest.getRequest(
                    this.endPoint + "/brands/get_valid_brands?mode=all",
                    null,
                    null
                );
                // brands.unshift({code: null, id: null, name: '' })
                this.brandOptions = brands;
                
            },

            // async getProductGroupOptions() {
            //     var product_groups = await HTTPRequest.getRequest(
            //         this.endPoint + "/product_groups/get_valid_product_groups",
            //         null,
            //         null
            //     );
            //     // brands.unshift({code: null, id: null, name: '' })
            //     this.productGroupOptions = product_groups;  
            // },
            async getDivisionOptions() {
                var divisions = await HTTPRequest.getRequest(
                    this.endPoint + "/categories/get_valid_categories?level=1",
                    null,
                    null
                );
                // brands.unshift({code: null, id: null, name: '' })
                this.divisionOptions = divisions;  
            },

            async getDepartmentOptions() {
                var departments = await HTTPRequest.getRequest(
                    this.endPoint + "/categories/get_valid_categories?level=2",
                    null,
                    null
                );
                // brands.unshift({code: null, id: null, name: '' })
                this.departmentOptions = departments;  
            },

            async getSubBrandData() {
                if (this.inputBrands != null) {
                    var subbrand_data = await HTTPRequest.getRequest(
                    this.endPoint +
                        "sub_brands/get_valid_sub_brands?brand_ids=" +
                        this.inputBrands,
                    null
                    );
                    // console.log("sub_brand[index]:",subbrand_data);
                    this.subBrandOptions = subbrand_data;
                    // console.log(this.inputSubBrands)
                }
            },

            async clearSubBrand() {
                this.inputSubBrands = [];
            },
        }
    };
</script>

<style></style>
